// rn-logo — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: inline-block;
    block-size: var(--run-logo-size, 24px);
    line-height: 0;
  }
  :host([size="sm"]) { block-size: var(--run-logo-size, 16px); }
  :host([size="md"]) { block-size: var(--run-logo-size, 24px); }
  :host([size="lg"]) { block-size: var(--run-logo-size, 32px); }
  :host([size="xl"]) { block-size: var(--run-logo-size, 48px); }

  [part="wrapper"] {
    display: contents;
  }

  svg {
    block-size: 100%;
    inline-size: auto;
  }

  /* tone=brand (default) */
  :host(:not([tone])) .fill-primary,
  :host([tone="brand"]) .fill-primary {
    fill: var(--run-logo-color-primary, var(--run-color-intent-primary-base));
  }
  :host(:not([tone])) .fill-wordmark,
  :host([tone="brand"]) .fill-wordmark {
    fill: var(--run-logo-color-wordmark, var(--run-color-text-primary));
  }

  /* tone=neutral */
  :host([tone="neutral"]) .fill-primary,
  :host([tone="neutral"]) .fill-wordmark {
    fill: currentColor;
  }

  /* tone=inverse */
  :host([tone="inverse"]) .fill-primary,
  :host([tone="inverse"]) .fill-wordmark {
    fill: var(--run-logo-color-inverse, var(--run-color-text-inverse));
  }

  /* forced-colors */
  @media (forced-colors: active) {
    .fill-primary,
    .fill-wordmark {
      fill: CanvasText;
    }
  }
`;

export function render(host) {
  const { variant } = host; // declared in MVA SkinModule.render contract

  const showSymbol = variant === 'full' || variant === 'symbol';
  const showWordmark = variant === 'full' || variant === 'wordmark';

  const symbolGroup = showSymbol ? `
      <g class="symbol fill-primary">
        <!-- symbol paths -->
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
      </g>` : '';

  const wordmarkGroup = showWordmark ? `
      <g class="wordmark fill-wordmark">
        <!-- wordmark paths -->
        <text x="26" y="16" font-size="10" font-family="sans-serif">RunsNative</text>
      </g>` : '';

  const svgWidth = variant === 'symbol' ? 24 : variant === 'wordmark' ? 120 : 144;

  // ARIA (role / aria-label / aria-hidden) lives on the HOST, owned by the
  // headless base — the skin renders presentation-only nodes.
  const svg = `<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 ${svgWidth} 24"
      aria-hidden="true"
      focusable="false"
    >${symbolGroup}${wordmarkGroup}</svg>`;

  host.shadowRoot.innerHTML = `<span part="wrapper">${svg}</span>`;
}
